module.exports = __webpack_public_path__ + "media/images/screenshots/data-f4f50ed1a3abaae8d18f32f0e9ed9238.png";